export default "__VITE_ASSET__e04fc94e__"